import React, { Component } from 'react';
import './../../assets/css/App.css';
import './../../assets/css/layout.css';
import './../../assets/css/themes/blue.css';
import 'bootstrap/dist/css/bootstrap.css';
import './../../assets/css/simple-line-icons/simple-line-icons.min.css';
import './../../assets/css/font-awesome/css/font-awesome.min.css';
import apiConfig from './../../config/config';

import SidebarLink from './sideBarLink'

class Sidebar extends Component {
    render() {
        return (
            <div className="page-sidebar navbar-collapse collapse">
                <ul className="page-sidebar-menu page-sidebar-menu-closed" data-auto-scroll="true" data-slide-speed="200">
                    <li className="sidebar-toggler-wrapper">

                    </li>
                    <SidebarLink linkUrl = '/reporting/dashboard'
                                 iconClass = 'fa fa-table'
                                 linkTitle = 'Dashboard Metrics'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/signupstats'
                                 iconClass = 'fa fa-users'
                                 linkTitle = 'Sign Up Statistics'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/packagestats'
                                 iconClass = 'fa fa-inbox'
                                 linkTitle = 'Package Statistics'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/shipmentstats'
                                 iconClass = 'fa fa-truck'
                                 linkTitle = 'Shipment Statistics'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/revenuestats'
                                 iconClass = 'fa fa-money'
                                 linkTitle = 'Revenue Statistics'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/countrystats'
                                 iconClass = 'fa fa-globe'
                                 linkTitle = 'Country Statistics'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/sourcestats'
                                 iconClass = 'fa fa-flag'
                                 linkTitle = 'Source Statistics'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/cannedreports'
                                 iconClass = 'fa fa-folder'
                                 linkTitle = 'Canned Reports'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/adhocreports'
                                 iconClass = 'fa fa-folder'
                                 linkTitle = 'Ad Hoc Reports'
                    ></SidebarLink>
                    <SidebarLink linkUrl = '/reporting/warehousereports'
                                 iconClass = 'fa fa-building-o'
                                 linkTitle = 'Warehouse Reports'
                    ></SidebarLink>
                </ul>
            </div>
        );
    }
}

export default Sidebar;
